// src/setupAuthedFetch.js
import { API_BASE } from "./config";
import { getAuthToken } from "./authToken";

if (!window.__AUTH_PATCHED__) {
  window.__AUTH_PATCHED__ = true;

  const nativeFetch = window.fetch.bind(window);
  const apiOrigin = (() => {
    try {
      return API_BASE ? new URL(API_BASE).origin : "";
    } catch {
      return "";
    }
  })();

  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === "string" ? input : input?.url;
      const target = new URL(url, window.location.origin);

      // Only inject for requests going to the API origin (if configured)
      if (apiOrigin && target.origin === apiOrigin) {
        const token = getAuthToken();
        if (token) {
          const headers = new Headers(init.headers || undefined);
          if (!headers.has("Authorization")) {
            headers.set("Authorization", `Bearer ${token}`);
          }
          init = { ...init, headers };
        }
      }
    } catch {
      // fall through
    }
    return nativeFetch(input, init);
  };
}
